module.exports = __webpack_public_path__ + "img/service (3).6c665641.png";